import React, { Suspense as ReactSuspense } from 'react';
import type { IProps } from './types';
import Spinner from '../../design-system/components/atoms/custom-spinner';

const Suspense: React.FC<IProps> = ({ children, fallback = <Spinner /> }) => (
  <ReactSuspense fallback={fallback}> {children} </ReactSuspense>
);

export default Suspense;
